{
  "$id": "module://custom-report-rename",
  "$schema": "wealthlane://schemas/domain",
  "title": "Custom Report Rename",
  "description": "Rename custom report (reportName + reportId)",
  "type": "object",
  "properties": {
    "reportId": {
      "type": "string",
      "title": "Report ID",
      "widget": "hidden"
    },
    "reportName": {
      "type": "string",
      "title": "Name",
      "widget": "text",
      "noBlank": true,
      "noDoubleSpace": true,
      "maxLength": 100,
      "required": true
    },
    "originalReportName": {
      "type": "string",
      "title": "Original name",
      "widget": "hidden"
    },
    "reportNameIsDuplicate": {
      "type": "boolean",
      "title": "Duplicate flag",
      "widget": "hidden"
    },
    "reportNameRemoteError": {
      "type": "string",
      "title": "Remote validation message",
      "widget": "hidden"
    }
  }
}
